// extracted by mini-css-extract-plugin
module.exports = {"dropbtn":"navs-module--dropbtn--2-QWh","dropdowncontent":"navs-module--dropdowncontent--1SZDS","dropdown":"navs-module--dropdown--dZ9Lo"};